import moment from 'moment';
import React from 'react';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import Table from '../../Components/Table/Table';
import { convertCost } from '../../Utils/functions';

const statusList = {
    Request : '입금대기',
    Deposit : '적립완료',
    Done : '정산완료'
}

const variant = {
    Request : 'primary',
    Deposit : 'normal',
    Done : 'success'
}

const JungsanHistory = () => {
    const modalRef = React.useRef(null);

    const columnsJungsan = React.useMemo(
        () => [
          {
            Header: '변동일시',
            accessor: 'Date.$date', // accessor is the "key" in the data
            disableFilters : true,
            width : 150,
            minWidth : 150,
            Cell : (props) => {
              return(
                  <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
              )
            }
          },
          {
            Header: '변동 전 금액',
            accessor: 'Before',
            disableFilters : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
              return(
                  <p style={{ fontWeight : 'bold', color : '#3f3f3f' }}>{convertCost(props.cell.value)} P</p>
              )
            }
          },
          {
            Header: '변동 금액',
            accessor: 'Variance',
            disableFilters : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
              return(
                  <p style={{ fontWeight : 'bold', color : '#3f3f3f' }}>{convertCost(props.cell.value)} P</p>
              )
            }
          },
          {
            Header: '변동 후 금액',
            accessor: 'After',
            disableSortBy : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
              return(
                  <p style={{ fontWeight : 'bold', color : '#3f3f3f' }}>{convertCost(props.cell.value)} P</p>
              )
            }
          },
          {
            Header: '완료일시',
            accessor: 'WithdrawDate.$date',
            disableFilters : true,
            minWidth : 150,
            width : 150,
            Cell : (props) => {
              if( typeof props.cell.value === 'undefined' ) return( <p>-</p>)
              else {
                return(
                  <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
                )
              }
            }
          },
          {
            Header: '처리상태',
            accessor: 'State',
            disableFilters : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
              return(
                <StatusBadge Status={statusList[props.cell.row.original.Type === 'Deposit' ? 'Deposit' : props.cell.value]} variant={variant[props.cell.row.original.Type === 'Deposit' ? 'Deposit' : props.cell.value]}/>
              )
            }
          },
        ]
    )

    return (
        <div>
            <Table columns={columnsJungsan} url={'/api/history/deposit'}/>
        </div>
    )
}

export default JungsanHistory;